import { partners, testimonials } from '@/mocks/siteData';

export default function PartnerSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            合作伙伴
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            500+品牌信赖之选
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            覆盖美妆、餐饮、科技、运动、母婴等多个行业，与行业头部品牌建立长期合作关系
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-5 mb-16">
          {partners.map((partner) => (
            <div
              key={partner}
              className="text-foreground-500 font-bold text-lg md:text-xl whitespace-nowrap hover:text-primary-500 transition-colors cursor-default"
            >
              {partner}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <div key={item.name} className="bg-background-50 rounded-2xl p-6 md:p-7">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}